__turbopack_context__.v({
  "blocksBackgroundColor": "LanguageTool-module-scss-module__esRHVa__blocksBackgroundColor",
  "blocksFontColor": "LanguageTool-module-scss-module__esRHVa__blocksFontColor",
  "container": "LanguageTool-module-scss-module__esRHVa__container",
  "dropdownButton": "LanguageTool-module-scss-module__esRHVa__dropdownButton",
  "dropdownContainer": "LanguageTool-module-scss-module__esRHVa__dropdownContainer",
  "dropdownItem": "LanguageTool-module-scss-module__esRHVa__dropdownItem",
  "dropdownMenu": "LanguageTool-module-scss-module__esRHVa__dropdownMenu",
  "heading1": "LanguageTool-module-scss-module__esRHVa__heading1",
  "heading2": "LanguageTool-module-scss-module__esRHVa__heading2",
  "icon": "LanguageTool-module-scss-module__esRHVa__icon",
  "inner": "LanguageTool-module-scss-module__esRHVa__inner",
  "languageButtonContainer": "LanguageTool-module-scss-module__esRHVa__languageButtonContainer",
  "languageButtonShadow": "LanguageTool-module-scss-module__esRHVa__languageButtonShadow",
  "learnMoreContainer": "LanguageTool-module-scss-module__esRHVa__learnMoreContainer",
  "secondaryNavBackgroundColor": "LanguageTool-module-scss-module__esRHVa__secondaryNavBackgroundColor",
  "selectContainer": "LanguageTool-module-scss-module__esRHVa__selectContainer",
  "sortDown": "LanguageTool-module-scss-module__esRHVa__sortDown",
  "themeBackgroundColor": "LanguageTool-module-scss-module__esRHVa__themeBackgroundColor",
  "themeFontColor": "LanguageTool-module-scss-module__esRHVa__themeFontColor",
  "themeFontFamily": "LanguageTool-module-scss-module__esRHVa__themeFontFamily",
  "translationElement": "LanguageTool-module-scss-module__esRHVa__translationElement",
  "translationElementModal": "LanguageTool-module-scss-module__esRHVa__translationElementModal",
  "whiteText": "LanguageTool-module-scss-module__esRHVa__whiteText",
});
